import { Box, Typography } from "@mui/material";

interface LoadingPageProps {
  message?: string;
}

export default function LoadingPage({ message = "Carregando..." }: LoadingPageProps) {
  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        py: 4,
      }}
    >
      <Box sx={{ display: 'flex', gap: 1 }}>
        {[0, 1, 2].map((i) => (
          <Box
            key={i}
            sx={{
              width: 12,
              height: 12,
              borderRadius: '50%',
              backgroundColor: 'primary.main',
              animation: 'bounce 1s infinite',
              animationDelay: `${i * 0.2}s`,
            }}
          />
        ))}
      </Box>

      {message && (
        <Typography variant="h6" sx={{ color: 'text.secondary' }}>
          {message}
        </Typography>
      )}

      <style>
        {`
          @keyframes bounce {
            0%, 80%, 100% {
              transform: scale(0);
              opacity: 0.3;
            }
            40% {
              transform: scale(1);
              opacity: 1;
            }
          }
        `}
      </style>
    </Box>
  );
}
